/* RealDonorHair — Shopify theme interactions
   AJAX cart drawer · scroll reveal · header state + parallax · 3D tilt+glare
   sticky add-to-cart · PDP gallery · countdown · exit popup */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
  var fine = matchMedia('(pointer:fine)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  /* ---------- Money ---------- */
  function money(cents) {
    var v = (cents || 0) / 100;
    var s = (Math.round(v) === v) ? v.toFixed(0) : v.toFixed(2);
    return (window.RDHCurrency&&window.RDHCurrency.format)?window.RDHCurrency.format(cents):(((window.Shopify&&Shopify.currency&&Shopify.currency.active)||'')+' '+s.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  /* ---------- Scroll reveal ---------- */
  (function () {
    var rv = $$('.reveal, .lrow');
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      rv.forEach(function (el) { io.observe(el); });
    } else { rv.forEach(function (el) { el.classList.add('in'); }); }
  })();

  /* ---------- Header scroll state + hero parallax ---------- */
  (function () {
    var header = $('.header');
    var heroImg = $('.hero__media video, .hero__media img');
    function onScroll() {
      if (header) header.classList.toggle('scrolled', scrollY > 12);
      if (!reduce && heroImg) {
        var y = Math.min(scrollY, 900);
        heroImg.style.transform = 'translate3d(0,' + (y * 0.16) + 'px,0) scale(1.06)';
      }
    }
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* ---------- Mobile nav ---------- */
  (function () {
    var b = $('.burger'), m = $('.mobilenav'), c = $('.mobilenav__close');
    if (b && m) b.addEventListener('click', function () { m.classList.add('open'); });
    if (c && m) c.addEventListener('click', function () { m.classList.remove('open'); });
    if (m) m.addEventListener('click', function (e) { if (e.target === m) m.classList.remove('open'); });
  })();

  /* ---------- 3D tilt + glare on product cards ---------- */
  if (!reduce && fine) {
    $$('.card__media').forEach(function (m) {
      var glare = m.querySelector('.card__glare');
      m.addEventListener('mousemove', function (ev) {
        var r = m.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width, py = (ev.clientY - r.top) / r.height;
        m.style.transform = 'perspective(900px) rotateX(' + ((0.5 - py) * 6) + 'deg) rotateY(' + ((px - 0.5) * 7) + 'deg) translateY(-4px)';
        if (glare) { glare.style.setProperty('--mx', (px * 100) + '%'); glare.style.setProperty('--my', (py * 100) + '%'); }
      });
      m.addEventListener('mouseleave', function () { m.style.transform = ''; });
    });
  }

  /* ---------- PDP gallery ---------- */
  (function () {
    var main = $('[data-gmain]');
    $$('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        $$('[data-thumb]').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active'); if (main) main.src = t.getAttribute('data-src');
      });
    });
  })();

  /* ---------- PDP variant / length selector ---------- */
  (function () {
    var form = $('.pdp__form'); if (!form) return;
    // legacy decorative length chips (single-variant products)
    var lenwrap = $('[data-lenwrap]', form);
    if (lenwrap) {
      var li = $('[data-len-input]', form);
      $$('.choice', lenwrap).forEach(function (ch) {
        ch.addEventListener('click', function (e) { e.preventDefault();
          $$('.choice', lenwrap).forEach(function (x) { x.classList.remove('active'); });
          ch.classList.add('active'); if (li) li.value = ch.textContent.trim(); });
      });
    }
    // real variants with price update
    var jsonEl = $('[data-variant-json]', form); if (!jsonEl) return;
    var variants; try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var rows = $$('[data-optrow]', form);
    var idField = $('[data-variant-id]', form);
    var priceNow = $('[data-price-now]');
    var atcPrice = $('[data-atc-price]', form);
    var stickyAdd = $('.stickybar [data-sticky-add]'), stickyPr = $('.stickybar .pr');
    function fmt(c) { if(window.RDHCurrency&&window.RDHCurrency.format) return window.RDHCurrency.format(c); var v = c / 100; var s = (Math.round(v) === v) ? v.toFixed(0) : v.toFixed(2); return (((window.Shopify&&Shopify.currency&&Shopify.currency.active)||'')+' '+s.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).trim(); }
    function selected() { return rows.map(function (r) { var a = r.querySelector('.choice.active'); return a ? a.getAttribute('data-val') : null; }); }
    function update() {
      var sel = selected();
      var match = variants.filter(function (v) { return v.opts.length === sel.length && v.opts.every(function (o, i) { return o === sel[i]; }); })[0];
      if (!match) return;
      if (idField) idField.value = match.id;
      if (priceNow) priceNow.textContent = fmt(match.price);
      if (atcPrice) atcPrice.textContent = fmt(match.price);
      if (stickyAdd) stickyAdd.setAttribute('data-variant-id', match.id);
      if (stickyPr) stickyPr.textContent = fmt(match.price);
    }
    rows.forEach(function (r) {
      $$('.choice', r).forEach(function (ch) {
        ch.addEventListener('click', function (e) { e.preventDefault();
          $$('.choice', r).forEach(function (x) { x.classList.remove('active'); });
          ch.classList.add('active'); update(); });
      });
    });
    update();
  })();

  /* ---------- Sticky add-to-cart bar ---------- */
  (function () {
    var sticky = $('.stickybar'), anchor = $('[data-atc-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); });
      }, { threshold: 0 }).observe(anchor);
    }
  })();



  /* ---------- PDP BOGO card: jump to the real bundle builder, not the old duplicate block ---------- */
  (function () {
    var links = $$('[data-scroll-bundle]');
    if (!links.length) return;
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.getElementById('bundle-builder') || $('[data-tierbox]');
        if (!target) return;
        e.preventDefault();
        var tier = target.querySelector('[data-tier][data-qty="2"]') || target.querySelector('[data-tier]');
        if (tier && !tier.classList.contains('is-on')) tier.click();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        target.classList.add('is-highlighted');
        setTimeout(function(){ target.classList.remove('is-highlighted'); }, 1600);
      });
    });
  })();

  /* ====================================================================
     AJAX CART DRAWER
  ==================================================================== */
  (function () {
    var cart = $('[data-cart-root]');
    if (!cart) return;
    var THRESHOLD = (parseFloat(cart.getAttribute('data-threshold')) || 69) * 100;
    var itemsEl = $('[data-cart-items]', cart);
    var busy = false, latestCart = null, priorityPrice = null;
    var PRIORITY_ID = String(cart.getAttribute('data-priority-id') || '').replace(/\D/g, '');
    var PRIORITY_HANDLE = cart.getAttribute('data-priority-handle') || 'priority-us-shipping';
    var GIFT_HANDLE = 'realcare-protection';
    var UPSELL_HANDLES = [
      cart.getAttribute('data-upsell-wig') || '',
      cart.getAttribute('data-upsell-bundle') || '',
      cart.getAttribute('data-upsell-universal') || ''
    ].filter(Boolean);
    var priorityToggle = cart.querySelector('[data-priority-toggle]');
    var priorityRow = cart.querySelector('[data-priority-row]');
    var priorityPriceEl = cart.querySelector('[data-priority-price]');
    var priorityStatus = cart.querySelector('[data-priority-status]');
    var STYLECASH_ENABLED = cart.getAttribute('data-stylecash-enabled') === 'true';
    var STYLECASH_RATE = parseFloat(cart.getAttribute('data-stylecash-rate')) || 10;
    var STYLECASH_MINIMUM = (parseFloat(cart.getAttribute('data-stylecash-minimum')) || 99) * 100;
    var STYLECASH_CAP = (parseFloat(cart.getAttribute('data-stylecash-cap')) || 25) * 100;
    var STYLECASH_DAYS = parseInt(cart.getAttribute('data-stylecash-days'), 10) || 31;
    var CART_WINDOW_MINUTES = parseInt(cart.getAttribute('data-cart-window-minutes'), 10) || 12;
    var cartWindow = $('[data-cart-window]', cart);
    var cartWindowTime = $('[data-cart-window-time]', cart);
    var cartWindowCopy = $('[data-cart-window-copy]', cart);
    var CART_WINDOW_KEY = 'rdh_cart_window_expires';
    var cartWindowInterval = null;
    function isPriority(it) { return String(it.variant_id) === PRIORITY_ID || it.handle === PRIORITY_HANDLE; }
    function isGift(it) { return it.handle === GIFT_HANDLE; }
    function realItems(c) { return c.items.filter(function (it) { return !isPriority(it) && !isGift(it); }); }
    function promotionItems(c) {
      return realItems(c).filter(function (it) {
        var text = [it.product_title, it.product_type, it.handle].join(' ').toLowerCase();
        if (UPSELL_HANDLES.indexOf(it.handle) !== -1) return false;
        if (/\b(accessory|accessories|shipping|bonnet|brush|bag|grip|adhesive|glue|edge control|curl set)\b/.test(text)) return false;
        return /\b(wig|wigs|bundle|bundles|weft|wefts|closure|frontal|ponytail|extension|extensions|clip-in|tape-in)\b/.test(text);
      });
    }
    function merchandiseSubtotal(c) { return realItems(c).reduce(function (sum, it) { return sum + (it.final_line_price || 0); }, 0); }
    function styleCashAmount(c) {
      var subtotal = merchandiseSubtotal(c);
      return STYLECASH_ENABLED && subtotal >= STYLECASH_MINIMUM ? Math.min(STYLECASH_CAP, Math.floor(subtotal * STYLECASH_RATE / 100)) : 0;
    }
    function getCartWindowExpiry() {
      try { return parseInt(sessionStorage.getItem(CART_WINDOW_KEY) || '0', 10) || 0; } catch (e) { return 0; }
    }
    function setCartWindowExpiry(value) {
      try {
        if (value) sessionStorage.setItem(CART_WINDOW_KEY, String(value));
        else sessionStorage.removeItem(CART_WINDOW_KEY);
      } catch (e) {}
    }
    function paintCartWindow() {
      if (!cartWindow || !cartWindowTime) return;
      var expiry = getCartWindowExpiry();
      var remaining = expiry - Date.now();
      if (!expiry || remaining <= 0) {
        cartWindowTime.textContent = '00:00';
        cartWindow.classList.add('is-expired');
        if (cartWindowCopy) cartWindowCopy.textContent = 'Window ended. Inventory and delivery timing are reconfirmed at checkout.';
        return;
      }
      var total = Math.max(0, Math.floor(remaining / 1000));
      var minutes = Math.floor(total / 60);
      var seconds = total % 60;
      cartWindow.classList.remove('is-expired');
      cartWindowTime.textContent = (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
      if (cartWindowCopy) cartWindowCopy.textContent = 'Complete checkout within this session window. Inventory is confirmed at checkout.';
    }
    function syncCartWindow(hasItems) {
      if (!cartWindow) return;
      cartWindow.hidden = !hasItems;
      if (!hasItems) {
        setCartWindowExpiry(0);
        if (cartWindowInterval) { clearInterval(cartWindowInterval); cartWindowInterval = null; }
        return;
      }
      if (!getCartWindowExpiry()) setCartWindowExpiry(Date.now() + CART_WINDOW_MINUTES * 60000);
      paintCartWindow();
      if (!cartWindowInterval) cartWindowInterval = setInterval(paintCartWindow, 1000);
    }

    function open() { cart.classList.add('open'); cart.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
    function close() { cart.classList.remove('open'); cart.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
    function setBusy(b) { busy = b; cart.classList.toggle('is-busy', b); }

    function render(c) {
      latestCart = c;
      var real = realItems(c);
      var promo = promotionItems(c);
      var priorityLine = c.items.filter(isPriority)[0];
      var hasPriority = !!priorityLine;
      var n = real.reduce(function (s, it) { return s + it.quantity; }, 0);
      var promoN = promo.reduce(function (s, it) { return s + it.quantity; }, 0);
      var firstPromoKey = promo.length ? promo[0].key : '';
      syncCartWindow(real.length > 0);
      $$('.cart-count').forEach(function (el) { el.textContent = n; });
      var headN = $('[data-cart-n]', cart); if (headN) headN.textContent = n + (n === 1 ? ' item' : ' items');
      var sub = $('[data-subtotal]', cart); if (sub) sub.textContent = money(c.total_price);
      var savings = Math.max(0, (c.original_total_price || 0) - (c.total_price || 0));
      if (!savings && c.total_discount) savings = c.total_discount;
      var sRow = $('[data-cart-savings-row]', cart), sVal = $('[data-cart-savings]', cart);
      if (sRow && sVal) { if (savings > 0) { sRow.hidden = false; sVal.textContent = '-' + money(savings); } else { sRow.hidden = true; } }
      var discountBox = $('[data-cart-discounts]', cart);
      if (discountBox) {
        var lines = [];
        (c.cart_level_discount_applications || []).forEach(function(d){ lines.push({title:d.title || 'Discount applied', amount:d.total_allocated_amount || 0}); });
        if (!lines.length && c.total_discount) lines.push({title:'Discount applied', amount:c.total_discount});
        discountBox.innerHTML = lines.map(function(d){ return '<div class="cart__discount-line"><span>✓ '+(d.title || 'Discount applied')+'</span><b>-'+money(d.amount || 0)+'</b></div>'; }).join('');
        discountBox.hidden = !lines.length;
      }
      var bogo = $('[data-cart-bogo]', cart);
      if (bogo) {
        var hasPromotion = promo.some(function(it){
          return (it.line_level_discount_allocations || []).length > 0 || it.original_line_price > it.final_line_price;
        }) || (c.cart_level_discount_applications || []).some(function(d){
          return /\b(bogo|buy one|get one|free style|two-look|four-look)\b/i.test(d.title || '');
        });
        bogo.innerHTML = promoN >= 4
          ? '<strong>Four-Look Wardrobe selected</strong><span>'+(hasPromotion?'Two lower-priced eligible styles discounted':'Offer selected — discount must appear below')+' • 2 Satin Protection Trios included</span>'
          : (promoN >= 2
            ? '<strong>Two-Look Set selected</strong><span>'+(hasPromotion?'Lower-priced eligible style discounted':'Offer selected — discount must appear below')+' • Satin Protection Trio included</span>'
            : '<strong>Build a Two-Look Set</strong><span>Add one more eligible style to qualify for the lower-priced style free offer.</span>');
      }
      if (priorityRow) priorityRow.hidden = !real.length || !PRIORITY_ID;
      if (priorityToggle) priorityToggle.checked = hasPriority;
      if (priorityPriceEl) {
        var shownPrice = priorityLine ? priorityLine.final_price : priorityPrice;
        priorityPriceEl.textContent = shownPrice !== null && shownPrice !== undefined ? money(shownPrice) : '';
      }
      if (priorityStatus) priorityStatus.textContent = hasPriority ? 'Added by your choice. Uncheck to remove.' : 'Not added.';
      var styleCashBox = $('[data-stylecash]', cart), styleCashValue = $('[data-stylecash-value]', cart), styleCashCopy = $('[data-stylecash-copy]', cart);
      var sc = styleCashAmount(c);
      if (styleCashBox) styleCashBox.hidden = !STYLECASH_ENABLED || !sc;
      if (styleCashValue && sc) styleCashValue.textContent = money(sc);
      if (styleCashCopy && sc) styleCashCopy.textContent = 'Non-cash store credit issued ' + STYLECASH_DAYS + ' days after delivery for a future order.';
      if (itemsEl) {
        if (!real.length) {
          itemsEl.innerHTML = '<div class="cart__empty"><p>Your cart is empty.</p><a href="/collections/all" class="btn btn--ghost" data-cart-close>Continue shopping</a></div>';
        } else {
          itemsEl.innerHTML = real.map(function (it, idx) {
            var bundleBadge = '';
            if(it.key === firstPromoKey && promoN >= 2){
              var badgeText = promoN >= 4 ? 'Four-Look Wardrobe' : 'Two-Look Set';
              var subText = promoN >= 4 ? '2 promotional styles • 2 care trios' : 'Lower-priced style promotion • care trio';
              bundleBadge = '<div class="citem__collection-badge"><b>'+badgeText+'</b><span>'+subText+'</span></div>';
            }
            var opt = (it.variant_title && it.variant_title.indexOf('Default') === -1) ? '<div class="citem__opt">' + esc(it.variant_title) + '</div>' : '';
            var cmp = (it.original_line_price > it.final_line_price) ? ' <s>' + money(it.original_line_price) + '</s>' : '';
            var curated = (window.RDH_PIMG && it.handle && window.RDH_PIMG[it.handle]) || '';
            var img = it.handle === 'edge-amp-lay-styling-kit' ? (it.image || curated) : (curated || it.image || '');
            if (img && img.indexOf('//') === 0) img = location.protocol + img;
            if (img && img.indexOf('width=') === -1) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=160';
            var imgHtml = img ? '<img src="' + esc(img) + '" alt="' + esc(it.product_title) + '" loading="lazy" width="160" height="200">' : '<div class="citem__ph"></div>';
            var propHtml = '';
            if (it.properties) {
              Object.keys(it.properties).forEach(function(k){
                if (k.charAt(0) === '_' || it.properties[k] === null || it.properties[k] === '') return;
                if (k === 'Fulfilment Note') return;
                propHtml += '<div class="citem__property"><b>'+esc(k)+':</b> '+esc(it.properties[k])+'</div>';
              });
            }
            var deals = '';
            (it.line_level_discount_allocations || []).forEach(function(a){ deals += '<div class="citem__deal">🎁 '+esc(a.discount_application && a.discount_application.title ? a.discount_application.title : 'Discount')+' <span style="white-space:nowrap">-'+money(a.amount || 0)+'</span></div>'; });
            if (!deals && it.original_line_price > it.final_line_price) { deals = '<div class="citem__deal">✓ Saving applied</div>'; }
            return '<div class="citem" data-key="' + it.key + '" data-price="' + it.final_price + '">' +
              '<div class="citem__img">' + imgHtml + '</div>' +
              '<div class="citem__main"><div class="citem__name">' + esc(it.product_title) + '</div>' + bundleBadge + opt + propHtml +
              '<div class="citem__qty"><button type="button" data-step="-" aria-label="Decrease">&minus;</button><span>' + it.quantity + '</span><button type="button" data-step="+" aria-label="Increase">+</button></div></div>' +
              '<div class="citem__right"><div class="citem__price" data-line>' + money(it.final_line_price) + cmp + '</div>' + deals +
              '<button type="button" class="citem__rm" data-rm>Remove</button></div></div>';
          }).join('');
        }
      }
      var bar = $('[data-ship-bar]', cart), msg = $('[data-ship-msg]', cart);
      var merchSubtotal = merchandiseSubtotal(c);
      var pct = Math.min(100, Math.round((merchSubtotal / THRESHOLD) * 100));
      if (bar) bar.style.width = pct + '%';
      if (msg) msg.innerHTML = merchSubtotal >= THRESHOLD
        ? 'You&rsquo;ve unlocked <b>FREE US shipping</b>'
        : 'You&rsquo;re <b>' + money(THRESHOLD - merchSubtotal) + '</b> away from <b>free US shipping</b>';
    }

    function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('Cart request failed'); return r.json(); }); }
    function postJSON(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error('Cart update failed'); return r.json(); });
    }
    function refresh() { return getCart().then(render); }
    window.RDHCart = { refresh: refresh, open: open, close: close, add: add, addItems: addItems };
    if (PRIORITY_ID && PRIORITY_HANDLE) {
      fetch('/products/' + encodeURIComponent(PRIORITY_HANDLE) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (p) {
          var v = (p.variants || []).filter(function (x) { return String(x.id) === PRIORITY_ID; })[0] || (p.variants || [])[0];
          if (v) { priorityPrice = v.price; if (priorityPriceEl && !(latestCart && latestCart.items.some(isPriority))) priorityPriceEl.textContent = money(priorityPrice); }
        }).catch(function () {});
    }
    if (priorityToggle) priorityToggle.addEventListener('change', function () {
      if (busy) { priorityToggle.checked = !priorityToggle.checked; return; }
      setBusy(true);
      if (priorityToggle.checked) {
        getCart().then(function (c) {
          if (c.items.some(isPriority)) { render(c); setBusy(false); return; }
          return postJSON('/cart/add.js', { items: [{ id: PRIORITY_ID, quantity: 1, properties: { '_RDH Upgrade': 'Customer selected' } }] })
            .then(getCart).then(render).then(function () { setBusy(false); });
        }).catch(function () { priorityToggle.checked = false; if (priorityStatus) priorityStatus.textContent = 'Could not add the upgrade. Please try again.'; setBusy(false); });
      } else {
        getCart().then(function (c) {
          var priorityLine = c.items.filter(isPriority)[0];
          if (!priorityLine) { render(c); setBusy(false); return; }
          return postJSON('/cart/change.js', { id: priorityLine.key, quantity: 0 }).then(render).then(function () { setBusy(false); });
        }).catch(function () { priorityToggle.checked = true; if (priorityStatus) priorityStatus.textContent = 'Could not remove the upgrade. Please try again.'; setBusy(false); });
      }
    });

    function add(id, qty) {
      setBusy(true);
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty || 1 })
      }).then(function (r) { if (!r.ok) throw new Error('Add to cart failed'); return r.json(); }).then(function () { return refresh(); })
        .then(function () { setBusy(false); open(); }).catch(function () { setBusy(false); });
    }
    function addItems(items) {
      setBusy(true);
      function collectionNote(){
        var plan = '', comp = 0;
        (items || []).forEach(function(it){
          var p = it.properties || {};
          if (!plan && (p['_RDH Collection'] || p['RDH Collection'])) plan = p['_RDH Collection'] || p['RDH Collection'];
          var role = String(p['_Collection Role'] || p['Collection Role'] || '').toLowerCase();
          if (role.indexOf('included') !== -1 || role.indexOf('complimentary') !== -1 || role.indexOf('promotional') !== -1 || role.indexOf('lower-priced') !== -1) comp++;
        });
        if (!plan) return Promise.resolve();
        var note = plan + ': ' + comp + ' lower-priced item' + (comp === 1 ? '' : 's') + ' should receive the configured Shopify BOGO discount. Include the Satin Protection Trio.';
        return fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note: note, attributes: { 'RDH Collection': plan, 'RDH Promotional Items': String(comp), 'RDH Included Gift': 'Satin Protection Trio', 'RDH Fulfilment Note': note } })
        });
      }
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if(!r.ok) throw 0; return r.json(); }).then(collectionNote).then(function () { return refresh(); })
        .then(function () { setBusy(false); open(); }).catch(function () { setBusy(false); throw 0; });
    }

    function change(key, qty) {
      setBusy(true);
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { if (!r.ok) throw new Error('Cart update failed'); return r.json(); }).then(render).then(function () { setBusy(false); }).catch(function () { setBusy(false); });
    }

    $$('[data-open-cart]').forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); refresh().then(open); });
    });
    addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    cart.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('[data-cart-close]');
      if (closeBtn) { e.preventDefault(); close(); return; }
      if (busy) return;
      var stepBtn = e.target.closest('[data-step]');
      var rmBtn = e.target.closest('[data-rm]');
      var row = e.target.closest('.citem'); if (!row) return;
      var key = row.getAttribute('data-key');
      var cur = parseInt(row.querySelector('.citem__qty span').textContent, 10) || 1;
      if (stepBtn) { change(key, Math.max(0, cur + (stepBtn.getAttribute('data-step') === '+' ? 1 : -1))); }
      else if (rmBtn) { change(key, 0); }
    });

    $$('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var idField = form.querySelector('[name="id"]');
        if (!idField || !idField.value) return;
        var qtyField = form.querySelector('[name="quantity"]');
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) { submitBtn.classList.add('is-loading'); submitBtn.disabled = true; }
        add(idField.value, qtyField ? (parseInt(qtyField.value, 10) || 1) : 1).then(function () {
          if (submitBtn) { submitBtn.classList.remove('is-loading'); submitBtn.disabled = false; }
        });
      });
    });

    var stickyAdd = $('.stickybar [data-sticky-add]');
    if (stickyAdd) stickyAdd.addEventListener('click', function (e) {
      var bundleBox = document.querySelector('[data-tierbox]');
      var productForm = document.querySelector('.pdp__form');
      if (bundleBox && productForm) { e.preventDefault(); if (productForm.requestSubmit) productForm.requestSubmit(); else productForm.dispatchEvent(new Event('submit', {cancelable:true, bubbles:true})); return; }
      var id = stickyAdd.getAttribute('data-variant-id');
      if (id) { e.preventDefault(); add(id, 1); }
    });

    var checkout = $('[data-cart-checkout]', cart);
    if (checkout) checkout.addEventListener('click', function (e) {
      if (busy) { e.preventDefault(); return; }
      e.preventDefault();
      setBusy(true);
      getCart().then(function (c) {
        var credit = styleCashAmount(c);
        var attributes = {
          'RDH Priority Upgrade': c.items.some(isPriority) ? 'Customer selected' : 'Not selected',
          'RDH StyleCash Status': credit ? 'Pending return window' : 'Not earned',
          'RDH StyleCash Amount': credit ? money(credit) : '',
          'RDH StyleCash Issue After': credit ? STYLECASH_DAYS + ' days after delivery' : ''
        };
        return postJSON('/cart/update.js', { attributes: attributes });
      }).then(function () {
        window.location.href = checkout.getAttribute('href') || '/checkout';
      }).catch(function () {
        setBusy(false);
        window.location.href = checkout.getAttribute('href') || '/checkout';
      });
    });

    refresh();
  })();

  /* ---------- Video lightbox (review wall) ---------- */
  (function () {
    var lb = $('.lightbox'); if (!lb) return;
    var v = lb.querySelector('video'), t = $('[data-lb-title]', lb), s = $('[data-lb-sub]', lb);
    var trig = $$('[data-video]'), cur = -1;
    function openAt(i) {
      if (i < 0) i = trig.length - 1; if (i >= trig.length) i = 0; cur = i;
      var el = trig[i];
      v.src = el.getAttribute('data-video');
      if (t) t.textContent = el.getAttribute('data-title') || '';
      if (s) s.textContent = el.getAttribute('data-sub') || '';
      lb.classList.add('open'); var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    function close() { lb.classList.remove('open'); v.pause(); }
    trig.forEach(function (el, i) { el.addEventListener('click', function () { openAt(i); }); });
    var cl = lb.querySelector('.lightbox__close'); if (cl) cl.addEventListener('click', close);
    var pv = lb.querySelector('.lightbox__nav.prev'), nx = lb.querySelector('.lightbox__nav.next');
    if (pv) pv.addEventListener('click', function () { openAt(cur - 1); });
    if (nx) nx.addEventListener('click', function () { openAt(cur + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    addEventListener('keydown', function (e) {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') openAt(cur - 1);
      if (e.key === 'ArrowRight') openAt(cur + 1);
    });
  })();

  /* ---------- Dispatch countdown ---------- */
  (function () {
    var els = $$('[data-countdown]'); if (!els.length) return;
    function fmt(d) { var h = Math.floor(d / 3.6e6), m = Math.floor(d % 3.6e6 / 6e4), s = Math.floor(d % 6e4 / 1e3); return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s; }
    function easternMsUntil(cutoff) {
      try {
        var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date());
        var values = {};
        parts.forEach(function (part) { if (part.type !== 'literal') values[part.type] = parseInt(part.value, 10); });
        var current = (values.hour % 24) * 3600 + values.minute * 60 + values.second;
        var target = cutoff * 3600;
        var seconds = target - current;
        if (seconds <= 0) seconds += 86400;
        return seconds * 1000;
      } catch (e) {
        var now = new Date(), t = new Date(now);
        t.setHours(cutoff, 0, 0, 0);
        if (now >= t) t.setDate(t.getDate() + 1);
        return Math.max(0, t - now);
      }
    }
    els.forEach(function (el) {
      var cutoff = parseInt(el.getAttribute('data-cutoff') || '16', 10);
      var out = el.querySelector('[data-cd]') || el;
      function tick() { out.textContent = fmt(easternMsUntil(cutoff)); }
      tick(); setInterval(tick, 1000);
    });
  })();

  /* ---------- Exit-intent / delayed offer popup ---------- */
  (function () {
    /* The VIP scratch popup owns its own timing, validation and close state. */
    var modal = $('.modal:not([data-rdh-gift-modal])'); if (!modal) return;
    var shown = false, dismissed = false;
    try { dismissed = localStorage.getItem('rdh_popup') === '1'; } catch (e) {}
    function show() { if (shown || dismissed) return; shown = true; modal.classList.add('open'); }
    function hide(remember) { modal.classList.remove('open'); if (remember) { try { localStorage.setItem('rdh_popup', '1'); } catch (e) {} dismissed = true; } }
    if (!dismissed) {
      setTimeout(show, 12000);
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) show(); });
    }
    var cl = modal.querySelector('.modal__close'); if (cl) cl.addEventListener('click', function () { hide(true); });
    var dc = modal.querySelector('.modal__decline'); if (dc) dc.addEventListener('click', function () { hide(true); });
    modal.addEventListener('click', function (e) { if (e.target === modal) hide(true); });
    addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('open')) hide(true); });
  })();
})();
